/**
 * Narrows an arbitrary string to one of a fixed set of literals.
 *
 * Lives here rather than in each app's own `src/utils/` because both apps need
 * exactly this guard to validate a persisted locale before handing it to
 * react-intl, and two copies of a narrowing helper drift silently — nothing
 * fails when a fix lands in one and not the other.
 *
 * The cast inside is the one place it belongs: `Array.prototype.includes` types
 * its argument as the array's element type, so a `string` cannot be passed
 * without it. Callers get the narrowing without casting at their own end.
 */
export const isOneOf = <T extends string>(value: string, values: readonly T[]): value is T =>
  values.includes(value as T)
